module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "component-client-reservations"
  }, [_c('div', {
    staticClass: "action-bar"
  }, [_vm._m(0), _c('div', {
    staticClass: "action"
  }, [_c('reservation-list-form', {
    attrs: {
      "type": 'entity-filter'
    },
    on: {
      "filterReservations": _vm.filterReservations
    }
  }), _c('i', {
    staticClass: "fa fa-plus-circle fa-2x",
    attrs: {
      "data-toggle": "create-reservation"
    }
  })], 1)]), _c('div', {
    staticClass: "tabs-inner-content no-horizontal-space client-reservations fill-bg"
  }, [_c('div', {
    directives: [{
      name: "f",
      rawName: "v-f"
    }],
    staticClass: "is-hidden",
    attrs: {
      "id": "create-reservation",
      "data-toggler": "is-hidden"
    }
  }, [(_vm.drivers.length > 0) ? _c('book-panel', {
    attrs: {
      "entityDrivers": _vm.drivers
    },
    on: {
      "reservationCreated": function($event) {
        return _vm.$refs.loader.loadData(1)
      }
    }
  }) : _vm._e()], 1), _c('base-list', {
    ref: "loader",
    attrs: {
      "component": _vm.component,
      "search": _vm.search,
      "dataLoader": _vm.dataLoader
    }
  })], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "title"
  }, [_c('h2', [_vm._v("Client Reservations")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-64b2768e!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/backoffice/tabbed/ClientReservations.vue
// module id = 2543
// module chunks = 1